import { useParams } from "react-router";
import { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "rebass/styled-components";
import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getLeagueAdmin } from "core-integration/src/store/leagues/reducers";
import {
  fetchH2HLeagueForAdmin,
  updateH2HLeague,
} from "core-integration/src/store/leagues/thunks";
import {
  IPrivateLeagueAdmin,
  IUpdateH2HLeagueData,
} from "core-integration/src/store/leagues/types";
import Copy from "../Copy";
import { Main, Wrapper } from "../Layout";
import Title from "../Title";
import AddBan from "./admin/AddBan";
import ChangeAdmin from "./admin/ChangeAdmin";
import Code from "./admin/Code";
import Delete from "./admin/Delete";
import H2HDetails from "./admin/H2HDetails";
import RemoveBan from "./admin/RemoveBan";

type Props = WithTranslation;

const AdminClassic = ({ t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const { leagueId } = useParams();

  const leagueNumber =
    leagueId && parseInt(leagueId, 10) ? parseInt(leagueId, 10) : 0;

  const league = useSelector((state: RootState) =>
    leagueNumber
      ? (getLeagueAdmin(state, leagueNumber) as IPrivateLeagueAdmin)
      : null,
  );

  const now = useSelector(getCurrentEvent);

  const updateLeague = (leagueId: number, data: IUpdateH2HLeagueData) =>
    dispatch(updateH2HLeague(leagueId, data));

  useEffect(() => {
    if (leagueNumber) {
      dispatch(fetchH2HLeagueForAdmin(leagueNumber));
    }
  }, [dispatch, leagueNumber]);

  if (!league) {
    return null;
  }
  const started = Boolean(now && now.id >= league.start_event);
  return (
    <Wrapper>
      <Main>
        <Copy>
          <Title>{t("leagues.adminTitle", "League Administration")}</Title>
          {!started && <Code league={league} />}
          <Box mt={4}>
            <H2HDetails league={league} started={started} />
          </Box>
          {!started && (
            <Box mt={4}>
              <AddBan league={league} />
            </Box>
          )}
          {!started && (
            <Box mt={4}>
              <RemoveBan league={league} />
            </Box>
          )}
          {!started && (
            <Box mt={4}>
              <ChangeAdmin
                league={league}
                updateAdmin={(entryId: number) =>
                  updateLeague(league.id, {
                    admin_entry: entryId,
                    closed: league.closed,
                    code_privacy: league.code_privacy,
                    ko_rounds: league.ko_rounds,
                    max_entries: league.max_entries,
                    name: league.name,
                    start_event: league.start_event,
                  })
                }
              />
            </Box>
          )}
          {!started && (
            <Box mt={4}>
              <Delete league={league} />
            </Box>
          )}
        </Copy>
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(AdminClassic);
